import { useContext } from 'preact/hooks';
import OptionButtonGroupContext from './OptionButtonGroupContext';

export default function useOptionButtonGroup() {
  return useContext(OptionButtonGroupContext);
}
